import { memo } from "react";
export function CustomButton({
  type,
  style = {},
  label,
  Icon,
  disabled,
  iconStyle = {},
  onClick = () => {},
  iconPosition = "after",
  className,
  children = null,
  iconType = "",
}) {
  return (
    <div className="center">
      <button
        type={type}
        onClick={(event) => {
          event.preventDefault();
          onClick();
        }}
        disabled={disabled}
        style={{
          height: "36px",
          borderRadius: "6px",
          border: "none",
          fontFamily: "Montserrat",
          fontStyle: "normal",
          fontWeight: "500",
          lineHeight: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "max-content",
          cursor: disabled ? "not-allowed" : "",
          ...style,
        }}
        className={`${className} ${disabled ? "disabled" : ""}`}
      >
        {iconPosition === "before" && Icon ? iconType == "svg" ? <img src={Icon} alt="Icon" style={{ marginRight: "8px", ...iconStyle }} /> : <Icon style={{ marginRight: "8px", ...iconStyle }} /> : null}
        {label || children}
        {iconPosition === "after" && Icon ? iconType == "svg" ? <img src={Icon} alt="Icon" style={{ marginLeft: "8px", ...iconStyle }} /> : <Icon style={{ marginLeft: "8px", ...iconStyle }} /> : null}
      </button>
    </div>
  );
}

export default memo(CustomButton);
